import { render } from "./index.vue?vue&type=template&id=0eddfee2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0eddfee2&scoped=true&lang=css"

import exportComponent from "/var/publish/zonghe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eddfee2"]])

export default __exports__